export enum CustomErrorCodes {
  AXIOS = "AxiosError",
  NO_DATA = "NoDataReceivedError",
  INVALID_DATA = "InvalidDataReceivedError",
}
